import * as Types from '../../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AiSummarizeDetectionVariables = Types.Exact<{
  input: Types.AISummarizeDetectionInput;
}>;

export type AiSummarizeDetection = {
  aiSummarizeDetection: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'private' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const AiSummarizeDetectionDocument = gql`
  mutation AiSummarizeDetection($input: AISummarizeDetectionInput!) {
    aiSummarizeDetection(input: $input) {
      streamName
      streamId
      pinned
      private
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type AiSummarizeDetectionMutationFn = Apollo.MutationFunction<
  AiSummarizeDetection,
  AiSummarizeDetectionVariables
>;

/**
 * __useAiSummarizeDetection__
 *
 * To run a mutation, you first call `useAiSummarizeDetection` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiSummarizeDetection` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiSummarizeDetection, { data, loading, error }] = useAiSummarizeDetection({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiSummarizeDetection(
  baseOptions?: Apollo.MutationHookOptions<AiSummarizeDetection, AiSummarizeDetectionVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AiSummarizeDetection, AiSummarizeDetectionVariables>(
    AiSummarizeDetectionDocument,
    options,
  );
}
export type AiSummarizeDetectionHookResult = ReturnType<typeof useAiSummarizeDetection>;
export type AiSummarizeDetectionMutationResult = Apollo.MutationResult<AiSummarizeDetection>;
export type AiSummarizeDetectionMutationOptions = Apollo.BaseMutationOptions<
  AiSummarizeDetection,
  AiSummarizeDetectionVariables
>;
export function mockAiSummarizeDetection({
  data,
  variables,
  errors,
}: {
  data: AiSummarizeDetection;
  variables?: AiSummarizeDetectionVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: AiSummarizeDetectionDocument, variables },
    result: { data, errors },
  };
}
